import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Grid, Dropdown, Input} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {typeServicesOptions} from '../../../common/dictionaries/forms';
import {DEALER_OPTIONS_LIST} from '../static/constansDealerOptions';
import {formsSections} from '../../../common/constants/ftr';

const formsTypes = ['FTR', 'RSR'];

class SearchFTRFilters extends Component {
  constructor(props) {
    super(props);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
  }
  
  getSectionsOptions() {
    return Object.keys(formsSections).map((element) => {
      return {'text': formsSections[element].name, 'value': element};
    });
  }

  getFormsTypesOptions() {
    return formsTypes.map((element) => {
      return {'text': element, 'value': element};
    });
  }

  updateTextFilters(filterName, value) {
    const {updateSearchFilters} = this.props;
    const finalvalue = value.toUpperCase();
    updateSearchFilters(finalvalue, filterName);
  }

  changeStartDate(date) {
    const {updateSearchFilters, startDateFilter, endDateFilter} = this.props;
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted !== startDateFilter) {
      updateSearchFilters(dateFormatted, 'startDateFilter');
    }

    if (
      !endDateFilter ||
      (endDateFilter && moment(date) > moment(endDateFilter))
    ) {
      updateSearchFilters(dateFormatted, 'endDateFilter');
    }
  }

  changeEndDate(date) {
    const {updateSearchFilters, endDateFilter} = this.props;
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    
    if (dateFormatted !== endDateFilter) {
      updateSearchFilters(dateFormatted, 'endDateFilter');
    }
  }

  render() {
    const {
      updateSearchFilters,
      showFiltersSection,
      dealerFilter,
      sectionFilter,
      formTypeFilter,
      formNumberFilter,
      ofpFilter,
      modelFilter,
      causeFilter,
      startDateFilter,
      endDateFilter,
      typeService} = this.props;

    if (!showFiltersSection) {
      return null;
    }

    return (
      <div className='filters-section'>
        <Grid columns='equal' textAlign='left'>
          <Grid.Row>
            <Grid.Column>
              <Dropdown
                selection
                options={DEALER_OPTIONS_LIST}
                search
                value={dealerFilter}
                onChange={(e, {value}) =>
                  updateSearchFilters(value, 'dealerFilter')
                }
                placeholder='Concesionario'
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                selection
                options={this.getSectionsOptions()}
                search
                value={sectionFilter}
                onChange={(e, {value}) =>
                  updateSearchFilters(value, 'sectionFilter')
                }
                placeholder='Sección'
              />
            </Grid.Column>
            <Grid.Column>
              <DatePicker
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                selected={
                  startDateFilter ?
                    moment(startDateFilter, noTimeZoneShortISODate).toDate() :
                    null
                }
                onChange={this.changeStartDate}
                locale='es'
                placeholderText='Fecha Inicio'
              />
            </Grid.Column>
            <Grid.Column>
              <DatePicker
                locale='es'
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                selected={
                  endDateFilter ?
                    moment(endDateFilter, noTimeZoneShortISODate).toDate() :
                    null
                }
                onChange={this.changeEndDate}
                disabled={!startDateFilter}
                minDate={moment(startDateFilter).toDate()}
                placeholderText='Fecha Fin'
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                selection
                options={this.getFormsTypesOptions()}
                search
                value={formTypeFilter}
                onChange={(e, {value}) =>
                  updateSearchFilters(value, 'formTypeFilter')
                }
                placeholder='Tipo Form'
              />
            </Grid.Column>
            <Grid.Column>
              <Input
                type='number'
                placeholder='Número de Form'
                value={formNumberFilter}
                onChange={(e, {value}) =>
                  this.updateTextFilters('formNumberFilter', value)
                }
              />
            </Grid.Column>
            <Grid.Column>
              <Input
                type='text'
                placeholder='O.F.P.'
                value={ofpFilter}
                onChange={(e, {value}) => this.updateTextFilters('ofpFilter', value)}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Input
                type='text'
                placeholder='Modelo del vehículo'
                value={modelFilter}
                onChange={(e, {value}) =>
                  this.updateTextFilters('modelFilter', value)
                }
              />
            </Grid.Column>
            <Grid.Column>
              <Input
                type='text'
                placeholder='Causa del Problema'
                value={causeFilter}
                onChange={(e, {value}) =>
                  this.updateTextFilters('causeFilter', value)
                }
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                selection
                options={typeServicesOptions}
                search
                value={typeService}
                onChange={(e, {value}) =>
                  updateSearchFilters(value, 'typeService')
                }
                placeholder='Tipo Servicio/Accesorios'
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default SearchFTRFilters;
